/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var InternalTagType;
(function (InternalTagType) {
    InternalTagType["Year"] = "YEAR";
    InternalTagType["Quarter"] = "QUARTER";
    InternalTagType["HalfYear"] = "HALF YEAR";
    InternalTagType["Month"] = "MONTH";
    InternalTagType["Version"] = "VERSION";
    InternalTagType["YearToDate"] = "YEAR TO DATE";
})(InternalTagType || (InternalTagType = {}));
export function InternalTagTypeFromJSON(json) {
    return InternalTagTypeFromJSONTyped(json, false);
}
export function InternalTagTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function InternalTagTypeToJSON(value) {
    return value;
}
